import { useParams } from "react-router";
import AssignmentForm from "../../../components/admin/assignments/AssignmentForm";
import { useGetAssignmentQuery } from "../../../features/assignments/assignmentsAPI";

function EditAssignment() {
  const { id: assignmentID } = useParams();
  const {
    data: assignment,
    isLoading,
    isError,
    isSuccess,
  } = useGetAssignmentQuery(assignmentID);

  let form = null;
  if (isLoading) form = "Loading...";
  else if (isError) form = "Something went wrong!";
  else if (isSuccess) form = <AssignmentForm initialData={assignment} />;

  return (
    <main
      className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B] mt-8 space-y-6"
      style={{ width: "75%" }}
    >
      <h1 className="mb-10 text-center lws-section-title">Edit Assignment</h1>

      <div className="max-w-3xl mx-auto">{form}</div>
    </main>
  );
}

export default EditAssignment;
